export const de = {
  pwa: {
    update: "Aktualisieren",
    updateDescription: "Ein neues App-Update wurde erkannt",
    updateTitle: "Update verfügbar",
  },
};
